import { useState, useEffect } from 'react';

const useDataFromDOM = (attributes: string[], target = 'react') => {
  const [dataState, setDataState] = useState({});

  useEffect(() => {
    const reactElement = document.getElementById(target);

    if (!reactElement) {
      console.error(`Element with id #${target} not found`);
      return;
    }

    const updateValues = () => {
      attributes.forEach(attribute => {
        try {
          const domValue = reactElement.getAttribute(attribute);
          if (domValue && domValue !== 'null' && domValue !== 'undefined') {
            const parsedAttr = JSON.parse(decodeURIComponent(domValue));
            setDataState(currentState => ({
              ...currentState,
              ...parsedAttr
            }));
          }
        } catch (error) {
          console.error(`Error reading ${attribute}: `, error);
        }
      });
    };

    updateValues();

    const observer = new MutationObserver(updateValues);
    observer.observe(reactElement, { attributes: true, attributeFilter: attributes });

    return () => {
      observer.disconnect();
    };
  }, []);

  return dataState;
};

export default useDataFromDOM;
